import CertificateGeneration from './CertificateGeneration';

function Certificates() {
  return (
    <div>
      <CertificateGeneration />
    </div>
  );
}

export default Certificates;
